import { BaseRestResource } from "../../../../infrastructure/BaseRestResource";
import httpResource from "../../../core/infrastructure/httpResource";

class CanvasResource extends BaseRestResource {
    constructor() {
        super(httpResource, 'mobile_assets/labels/v2');
    }
}

const canvasResource = new CanvasResource();

export default canvasResource;